import React from 'react'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'

import { makeStyles, Theme } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'

import Species from './Species'
import TrcVersion from './TrcVersion'
import SearchTerms from './SearchTerms'
import Validation from './Validation'

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(14),
    margin: theme.spacing(2, 0, 2, 0),
  },
  textarea: {
    backgroundColor: theme.palette.background.grey,
    overflow: 'auto',
    fontFamily: 'inherit',
    margin: theme.spacing(1, 25, 0, 0),
    borderRadius: '5px',
    resize: 'none',
    height: theme.spacing(25),
  },
  margin: {
    margin: theme.spacing(4, 0, 2, 0),
  },
  marginLeft: {
    margin: theme.spacing(0, 2, 0, 0),
  },
  contentWraper: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(4),
  },
  chip: {
    padding: theme.spacing(2, 0, 0, 2),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'justify',
  },
  divider: {
    backgroundColor: theme.palette.grey[400],
    height: theme.spacing(15),
    marginTop: theme.spacing(10),
  },
  searchButton: {
    margin: theme.spacing(4, 0, 0, 0),
  },
  heading: {
    fontSize: theme.typography.pxToRem(20),
  },
}))

const GenesSearch = (): JSX.Element => {
  const classes = useStyles()
  return (
    <div>
      <Paper className={classes.paper}>
        <Grid container spacing={1}>
          <Grid item xs={2}>
            <Species />
          </Grid>
          <Grid item>
            <Divider orientation="vertical" className={classes.divider} />
          </Grid>
          <Grid item xs={2}>
            <TrcVersion />
          </Grid>
          <Grid item>
            <Divider orientation="vertical" className={classes.divider} />
          </Grid>
          <Grid item xs={2}>
            <Validation />
          </Grid>
          <Grid item>
            <Divider orientation="vertical" className={classes.divider} />
          </Grid>
          <Grid item xs={5}>
            <SearchTerms />
          </Grid>
        </Grid>
      </Paper>
    </div>
  )
}

export default GenesSearch
